module.exports = "1. If you are using an ad blocker, disable it for this step. Some ad blockers have a tendency to block data.\n\n2. The logging intervals can take more or less than 60 seconds, because the _setInterval()_ function is not always precise.\n"


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/en/installationNotes.md
// module id = ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/en/installationNotes.md
// module chunks = 8